import { memo, useState } from 'react';
import { ImageErrorEventData } from 'react-native';
import { Image } from '@bonanza-social/moonlight';
import { CommunityJackpotImageProps } from './CommunityJackpotImage.types';

function CommunityJackpotImage({
  url,
  fallback,
  ...rest
}: CommunityJackpotImageProps) {
  const [error, setError] = useState<ImageErrorEventData>();

  return (
    <Image
      {...(url && !error ? { source: url } : { name: fallback })}
      onError={setError}
      {...rest}
    />
  );
}

export default memo(CommunityJackpotImage);
